module.exports = __webpack_public_path__ + "static/media/blog-img-02.bb9065e1.jpg";